module.exports = __webpack_public_path__ + "media/images/reseller-cover-8a26c13227fa1f7385741516a44a15f1.png";